<div
  #editor
  class="code-editor json-editor"
  [class.invalid]="!isValid"
  [style.height]="height || '300px'"
></div>
<div class="error-message">
  <span *ngIf="errorMessage">{{ errorMessage }}</span>
</div>
